import Vue from 'vue'
import _ from 'lodash'

export const itemErrors = Vue.observable({ arr: [] })

export default {
    get () {
      return itemErrors.arr
    },
    set ( item ) {
      let find = _.find( itemErrors.arr, (elem) => {
        if( _.matches( item )( elem ) ) {
          return elem;
        }
      })
      if ( find === undefined ) {
        itemErrors.arr.push(item)
      }
    },
    update ( src, status ) {
      let findElement = itemErrors.arr.filter( item => item.src === src )
      if ( findElement.length ) findElement[0].added = status
    },
    remove ( src) {
      itemErrors.arr.splice(itemErrors.arr.findIndex( item => item.src === src ), 1)
    },
    clear () {
      itemErrors.arr = []
    }
}